import React from 'react';

// One sub_feature row in the feature access detail page.
// state:  "inherited" | "enabled" | "disabled" | "revert"
//   "inherited" = no row in DB; effective state comes from plan baseline
//   "enabled"   = explicit ON override
//   "disabled"  = explicit OFF override
//   "revert"    = pending delete of an existing override
const FeatureOverrideRow = ({
  subFeature,
  effectiveOn,        // boolean — current effective state shown to user
  override,           // { state, reason } | null  — what's in the DB now
  pendingState,       // "enabled" | "disabled" | "revert" | null — set when user toggles
  pendingReason,
  onToggle,           // user clicked the switch
  onChangeReason,
  onRevert,
}) => {
  const isOverridden = override !== null;
  const isPendingChange = pendingState !== null;

  return (
    <div className="flex items-start justify-between gap-4 py-3 border-b border-border last:border-b-0">
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-foreground">{subFeature.label}</div>
        {subFeature.description && (
          <div className="text-xs text-muted-foreground mt-0.5">{subFeature.description}</div>
        )}
        <div className="text-xs text-muted-foreground mt-1">
          {isOverridden && !isPendingChange && (
            <>
              Overridden{' '}
              <button onClick={onRevert} className="text-primary hover:underline ml-1">
                Revert to inherit
              </button>
            </>
          )}
          {!isOverridden && !isPendingChange && (
            subFeature.plan_gated ? 'From plan' : 'Default on'
          )}
          {isPendingChange && (
            <span className="text-yellow-600">Pending change</span>
          )}
        </div>

        {isPendingChange && pendingState !== 'revert' && (
          <div className="mt-2 flex flex-col gap-2">
            <input
              type="text"
              value={pendingReason || ''}
              onChange={(e) => onChangeReason(e.target.value)}
              placeholder="Reason (e.g., beta access)"
              className="text-sm border border-input rounded-lg px-2 py-1"
            />
          </div>
        )}
      </div>

      <div className="flex-shrink-0">
        <button
          type="button"
          role="switch"
          aria-label={subFeature.label}
          onClick={onToggle}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${
            effectiveOn ? 'bg-primary' : 'bg-gray-200'
          }`}
          aria-checked={effectiveOn}
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-card transition ${
              effectiveOn ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
      </div>
    </div>
  );
};

export default FeatureOverrideRow;
